// extracted by mini-css-extract-plugin
export default {"btn":"btn-ZwLdP","icon":"icon-Lk8KM"};